export interface LoginResponse {
  Authorization: string;
  roles: string;
  userId: number;
}
